import { render, staticRenderFns } from "./Concept.vue?vue&type=template&id=3d3acd49&"
import script from "./Concept.vue?vue&type=script&lang=tsx&"
export * from "./Concept.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports